import React, {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useHistory} from 'react-router-dom'
import {useFormik} from 'formik'
import PrivateRequest from '../../api/PrivateRequest'

import toast, {Toaster} from 'react-hot-toast'
import FadeIn from 'react-fade-in'
import request from '../../api/request'

const initialValues = {
  verify_code: '',
  password: '',
  reset_password: ''
}

const VerfyCodeSchema = Yup.object().shape({
  verify_code: Yup.string().required('فیلد کد بازیابی اجباری است '),
})

type UserProps = {
  mobile_number? : string,
  national_code? : string,
  reset_code?: number | string
}

export function VerifyCode({mobile_number, national_code, reset_code}: UserProps) {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  let history = useHistory()
  const formik = useFormik({
    initialValues,
    validationSchema: VerfyCodeSchema,
    onSubmit: (values, {setStatus, setSubmitting}) => {
      setLoading(true)
      setHasErrors(undefined)
      request.post('/changepassword', {
        reset_code: values.verify_code,
        mobile_number: mobile_number,
        national_code: national_code,
        password: values.password,
        reset_password: values.reset_password
      })
        .then((res: any) => {         
          toast.success(res.data.msg)
          console.log('res forget', res)
          setTimeout(() => {
            history.push('/auth/login?status=changepassword')
          }, 1500);
          setLoading(false)
        })
        .catch((err) => {
          toast.error(err.response.data.err)
          setLoading(false)
          toast.error(err.response.data.err)
          console.log('err forget', err)
        })
    },
  })

  return (
    <>
      <Toaster />
      <FadeIn>
        <form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_password_reset_form'
          onSubmit={formik.handleSubmit}
        >
          <div className='text-center mb-10'>
            {/* begin::Title */}
            <h1 className='text-dark mb-3'> بازیابی رمز عبور </h1>
            {/* end::Title */}

            {/* begin::Link */}
            <div className='text-gray-400 fw-bold fs-4'>
              برای بازیابی رمز عبور کد ارسالی و رمز عبور جدید را وارد کنید
            </div>
            {/* end::Link */}
          </div>

          {/* begin::Title */}
          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>
                خطایی پیش امده لطفا پند لحظه بعد مجددا امتحان کنید
              </div>
            </div>
          )}

          {hasErrors === false && (
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>کد تغییر رمز عبور برای شماره شما پیامک شد</div>
            </div>
          )}
          {/* end::Title */}

          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6 flex justify-end'>
              کد ارسالی
            </label>
            <input
              type='text'
              style={{direction: 'rtl'}}
              dir={'rtl'}
              placeholder='    کد بازیابی رمز را وارد کنید  '
              autoComplete='off'
              {...formik.getFieldProps('verify_code')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.verify_code && formik.errors.verify_code},
                {
                  'is-valid': formik.touched.verify_code && !formik.errors.verify_code,
                }
              )}
            />
            {formik.touched.verify_code && formik.errors.verify_code && (
              <div className='fv-plugins-message-container flex justify-content-end mt-2'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.verify_code}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6 flex justify-end'>
              رمز عبور جدید
            </label>
            <input
              type='text'
              style={{direction: 'rtl'}}
              dir={'rtl'}
              placeholder='    کد بازیابی رمز را وارد کنید  '
              autoComplete='off'
              {...formik.getFieldProps('password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.password && formik.errors.password},
                {
                  'is-valid': formik.touched.password && !formik.errors.password,
                }
              )}
            />
            {formik.touched.password && formik.errors.password && (
              <div className='fv-plugins-message-container flex justify-content-end mt-2'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.password}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}
          {/* begin::Form group */}
          <div className='fv-row mb-10'>
            <label className='form-label fw-bolder text-gray-900 fs-6 flex justify-end'>
              تکرار رمز عبور جدید{' '}
            </label>
            <input
              type='text'
              style={{direction: 'rtl'}}
              dir={'rtl'}
              placeholder='    کد بازیابی رمز را وارد کنید  '
              autoComplete='off'
              {...formik.getFieldProps('reset_password')}
              className={clsx(
                'form-control form-control-lg form-control-solid',
                {'is-invalid': formik.touched.reset_password && formik.errors.reset_password},
                {
                  'is-valid': formik.touched.reset_password && !formik.errors.reset_password,
                }
              )}
            />
            {formik.touched.reset_password && formik.errors.reset_password && (
              <div className='fv-plugins-message-container flex justify-content-end mt-2'>
                <div className='fv-help-block'>
                  <span role='alert'>{formik.errors.reset_password}</span>
                </div>
              </div>
            )}
          </div>
          {/* end::Form group */}

          {/* begin::Form group */}
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button
              type='submit'
              id='kt_password_reset_submit'
              className='btn btn-lg bg-teal rounded-pill btn-primary fw-bolder me-4 m-2'
            >
              {loading === false && <span className='indicator-label'> بازیابی رمز عبور </span>}
              {loading === true && (
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              )}
            </button>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn rounded-pill bg-gray-200 btn-lg btn-light-primary fw-bolder m-2'
                disabled={formik.isSubmitting || !formik.isValid}
              >
                انصراف
              </button>
            </Link>{' '}
          </div>
          {/* end::Form group */}
        </form>
      </FadeIn>
    </>
  )
}
